import React from 'react'
import ProfileItemForm from "./ProfileItemForm";
import { FormInputComponent } from "../../../components/form/Form";
import ProfileReferenceRow from "../../profiles/components/ProfileReferenceRow";
import {
    canonicalLinkedInProfileUrl,
    linkedInProfileUrlRule
} from "../../../components/form/linkedInProfileUrl";

export default class ReferenceForm extends ProfileItemForm {

    static ItemType = 'Reference'

    static FormClass = 'talent-role-form talent-interest-form add-talent-form '

    static ShowProfilePreview = false;

    // static TypeConfig = {
    //     icon: 'fas fa-handshake',
    //     color: '#aaacad'
    // }

    canEdit() {
        return !this.props.model?.is_confirmed;
    }

    getModelFromProps() {
        return this.props.model || {};
    }


    /**
     * Confirm deletion
     */
    async onDelete() {
        if (!this.props.user?.isApplicationApproved() && this.props.user.talent_references?.length <= 1) {
            return TB.alert(
                'error',
                `Minimum # of References Required`,
                'You must have at least 2 references. If you want to remove this reference, add another one first and then try again.'
            )
        }

        return super.onDelete();
    }
    /**
     * Handles form change
     *
     * @returns void
     */
    onChange(model = {}) {
        return this.setState({ model: { ...this.getModelFromProps(), ...model } })
    }

    /**
     * Handles form submit button clicks when form is valid
     *
     * @returns void
     */
    onSubmit() {
        let model = {
            ...this.state.model
        };

        // Store the canonical profile URL rather than whatever was pasted in
        let canonical = canonicalLinkedInProfileUrl(model.linkedin_profile_url);
        if (canonical) {
            model.linkedin_profile_url = canonical;
        }

        return super.onSubmit(model);
    }
    /**
     * The fields mapping for the form
     */
    formFields = () => {
        let otherUserReferences = TB.filter(this.props.user.talent_references || [], ref => !!ref.id && ref.id !== this.props.model.id);

        let emailsTaken = TB.map(otherUserReferences, 'email');
        let linkedInsTaken = TB.filter(
            TB.map(otherUserReferences, ref => canonicalLinkedInProfileUrl(ref.linkedin_profile_url)),
            url => !!url
        );
        if (this.props.model?.is_confirmed) return null;
        return [
            {
                style: styles.fieldSection,
                fields: {
                    first_name: {
                        style: styles.field,
                        columns: 6,
                        component: (
                            <FormInputComponent
                                type="text"
                                maxLength={255}
                                fieldName="first_name"
                                required={true}
                                value={this.state.model.first_name}>
                            </FormInputComponent>
                        )
                    },
                    last_name: {
                        style: styles.field,
                        columns: 6,
                        component: (
                            <FormInputComponent
                                type="text"
                                maxLength={255}
                                fieldName="last_name"
                                required={true}
                                value={this.state.model.last_name}>
                            </FormInputComponent>
                        )
                    },
                }
            },
            {
                style: styles.fieldSection,
                fields: {
                    email: {
                        style: styles.field,
                        columns: 6,
                        component: (
                            <FormInputComponent
                                type="email"
                                maxLength={255}
                                fieldName="email"
                                required={true}
                                validation={{
                                    rules: {
                                        isEmail: true,
                                        emailsTaken: function (model, value) {
                                            if (emailsTaken.includes(value)) {
                                                return "Reference email already used"
                                            }
                                            return true
                                        },
                                    },

                                }}
                                value={this.state.model.email}>
                            </FormInputComponent>
                        )
                    },
                    linkedin_profile_url: {
                        style: styles.field,
                        columns: 6,
                        component: (
                            <FormInputComponent
                                type="url"
                                maxLength={255}
                                label={`${TB.trans('talent.bio.linkedin_profile_url_label')} (Include https://)`}
                                placeholder={TB.trans('talent.bio.linkedin_profile_url_placeholder')}
                                fieldName="linkedin_profile_url"
                                required={true}
                                validation={{
                                    rules: {
                                        isLinkedInProfileUrl: linkedInProfileUrlRule,
                                        linkedInsTaken: function (model, value) {
                                            if (linkedInsTaken.includes(canonicalLinkedInProfileUrl(value))) {
                                                return "Reference LinkedIn already used"
                                            }
                                            return true
                                        },
                                    },
                                }}
                                value={this.state.model.linkedin_profile_url}>
                            </FormInputComponent>
                        )
                    }
                },
            }
        ];
    };



    renderTitle() {
        // console.log(this.state, this.props, 'state and props')

        const { id, is_confirmed, is_recommended, comments, linkedin_profile_url, image_path, first_name, last_name, email } = this.state.model;

        const { isEditing, disabled } = this.props;
        let status;

        if (id && !is_confirmed) {
            status = {
                className: 'bg-yellow-100 text-yellow-800',
                title: 'Email Sent, Pending Response',
            }
        } else if (id) {
            status = {
                className: 'bg-green-100 text-green-800',
                title: 'Completed',
            }
        }

        const referenceIndex = this.props.talent_references.findIndex(reference => reference.id === id);

        return (
            <div className="form-title-section">
                <div className="step-title-content w-full">
                    <div>
                        <h3 className="form-title">
                            Reference #{referenceIndex + 1}
                        </h3>
                    </div>
                    {/*<div className="flex-none text-right flex flex-col items-end">*/}
                    {/*    {!!Object.keys(this.props.model).length && status && (*/}
                    {/*        <p className={`inline-block text-xs font-medium px-2.5 py-0.5 rounded ${status.className}`}>{status.title}</p>*/}
                    {/*    )}*/}
                    {/*</div>*/}
                </div>

                {/* TODO: Only show if recommended, include linkedin picture if available. Add a label for comments - Reference Feedback */}
                {!!is_confirmed && (
                    <div className="px-[15px] pt-4">

                        <div className="flex items-center gap-8 pb-6">
                            <div>
                                <img
                                    src={image_path || '/images/alt_user.png'}
                                    alt={`${first_name} ${last_name} profile`}
                                    className="h-[60px] w-[60px] rounded-full"
                                />
                            </div>
                            <div>
                                <p className="text-sm font-bold">Name</p>
                                <p>{first_name} {last_name}</p>
                            </div>
                            <div>
                                <p className="text-sm font-bold">Email</p>
                                <p>{email}</p>
                            </div>
                            <div>
                                <p className="invisible">Profile</p>
                                <a href={linkedin_profile_url} className="text-sm btn btn-link-primary">Visit LinkedIn Profile</a>
                            </div>
                        </div>

                        {/* <p>
                            {comments}
                        </p> */}
                    </div>
                )}
            </div>
        )
    }

    renderProfilePreview() {
        return (
            <div className="px-4">
                <ProfileReferenceRow reference={this.getModelFromProps()} />
            </div>
        )
    }
}

const styles = {
    fieldSection: {
        flexDirection: 'row'
    },
    field: {
        padding: '0 15px',
    },
};